import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {  Col, Row } from "react-bootstrap";
import classes from "./UIStyles.module.scss"
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

const SuccessAlert =({text, ...props})=>{
    return(
        <Row className={classes["successAlert"]} {...props}>
            <Col className="col-1"><ThumbUpIcon style={{width:"2rem", height:"2rem", color:"green"}} /></Col>
            <Col>{text}</Col>
        </Row>
        )
}

export default SuccessAlert;